<template>
  <div class="px-16">
    <c-label :color="$theme.COLOR.UI.UI13" :weight="500" :size="16" :lineHeight="16"
      >{{ $t('title.mainPerformanceTop') }}
    </c-label>
    <div class="content-wrapper">
      <div class="area">
        <ConfigTitle required class="title"
          >{{ $util.capitalize($t('label.widgetName')) }}
        </ConfigTitle>
        <lego-text-field
          ref="widgetName"
          :rules="validator.widgetName"
          :modelValue="widgetName"
          counter="100"
          showCounter
          :guide="$t('hint.common') + ' ' + $t('hint.notStartWithDot')"
          @update:modelValue="(value) => changeWidgetName(value)"
          isFreeText
        />
      </div>
      <BoxRegion class="area" />
      <div class="area">
        <ConfigTitle required class="title"
          >{{ $util.capitalize($t('label.product')) }}
        </ConfigTitle>
        <scpm-tree-dropdown
          ref="resourceTypeModel"
          :rules="validator.resourceTypeModel"
          :items="productTypeGroups"
          v-model="resourceTypeModel"
          @update:modelValue="
            onResourceTypeChange();
            changeData();
          "
          :disabled="isDisabled"
        />
        <lego-dropdown
          style="margin-top: 10px"
          v-if="isChildResourceType"
          :items="childResourceTypeItems"
          v-model="childResourceTypeModel"
          @update:modelValue="
            onChildResourceType();
            changeData();
          "
          :disabled="isDisabled"
        />
      </div>
      <div class="area performance">
        <ConfigTitle required class="title"
          >{{ $util.capitalize($t('label.performance')) }} {{ $t('label.item') }}
          <template v-slot:message v-if="isMessageShow && !(metricModel.length > 0)">
            <div class="message">
              {{ $t('message.select1', [$t('label.performance') + ' ' + $t('label.item')]) }}
            </div>
          </template>
        </ConfigTitle>
        <lego-checkbox-wrapper
          ref="metricChecked"
          :rules="validator.metricChecked"
          v-model="metricModel"
          @update:modelValue="
            onConfigChange();
            changeData();
          "
        >
          <lego-checkbox
            v-for="(item, index) in metricItems"
            :key="index"
            :value="item.value"
            class="check_vertical"
            :disabled="isDisabled"
            :isEllipsis="false"
          >
            <div>
              <span>{{ item.text }}</span>
              <lego-tooltip-extend-v-2
                custom-style="width: 300px"
                :leftAlign="30"
                :top="true"
                :mouseOver="true"
              >
                <TooltipPerformanceItem :dataTooltip="{ metric: item }" />
              </lego-tooltip-extend-v-2>
            </div>
          </lego-checkbox>
        </lego-checkbox-wrapper>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import configMixin from './configMixin';
import { getResourceTypeDatas, getSummaryMetricDatas } from '../serviceApi';
import TooltipPerformanceItem from '@/containers/components/TooltipPerformanceItem.vue';
import LegoTooltipExtendV2 from '../../../components/lego/extend/legoTooltipExtendV2.vue';
import validateFieldsMixin from '@/mixins/validateFields.mixin';
import { useProductTypeGroups } from '@/composables/useProductTypeGroups.js';
import { GLOBAL_CDN } from '@/containers/utils/constant';

const { getProductTypeGroups } = useProductTypeGroups();

export default {
  components: { TooltipPerformanceItem, LegoTooltipExtendV2 },
  props: ['configItems'],
  mixins: [configMixin, validateFieldsMixin],
  emits: ['update:changeField', 'changeValidate', 'configModify'],
  computed: {
    // 하위 상품 존재 여부
    isChildResourceType() {
      return [
        'Kubernetes',
        'Load Balancer',
        'DataOps',
        'DataFlow',
        'QuickQuery',
        'DataWrangler'
      ].includes(this.resourceTypeModel);
    },
    isDisabled() {
      return this.isModifyMode || !this.isAccountAuth;
    }
  },
  data() {
    return {
      isChanged: false,
      widgetName: '', // 위젯명
      resourceTypeItems: [], // 상품 유형정보
      resourceTypeModel: '', // 선택한 상품 유형
      resourceTypeName: '', // 상품유형명
      productTypeGroups: [],
      metricItems: [], // 성능항목
      metricModel: [], // 선택한 성능 항목
      childResourceTypeItems: [], // 하위 상품 유형
      childResourceTypeModel: '', // 하위 선택한 상품 유형
      defaultConfig: this.config({
        widget: {
          type: 'PerfermanceTop5Widget',
          api: '/cloudmonitorings/product/v1/console/metric-data-tops',
          options: {}
        }
      }),
      isMessageShow: false, // validate message
      tempWidgetName: '', // 기존 widget name
      tempResourceTypeModel: '', // 기존 선택한 상품유형,
      isResourceTypeAuth: true, // 상품 유형 권한
      validator: {
        widgetName: [this.checkWidgetName],
        resourceTypeModel: [this.checkResourceTypeModel],
        metricChecked: [
          this.checkMetricEmpty ||
            this.$t('message.select1', [this.$t('label.performance') + this.$t('label.item')])
        ]
      },
      validateFieldKey: 'perfermanceTop5WidgetConfig'
    };
  },
  watch: {
    changedFieldData: {
      handler(value) {
        this.$emit('update:changeField', value);
      },
      immediate: true
    }
  },
  methods: {
    updateFieldsBeforeModify() {
      this.setFieldsBeforeModify();
    },
    async getListProductAndPerformanceItem() {
      if (this.isAccountAuth) {
        await this.getProductSubTypes();
        await this.onResourceTypeChange(false);
      } else {
        this.childResourceTypeItems = [];
        this.childResourceTypeModel = '';
        this.metricItems = [];
        this.metricModel = [];
        this.onConfigChange();
      }
    },

    changeData() {
      this.isChanged = true;
      const check = this.validateBtnComfirm();
      this.$emit('changeValidate', check);
    },
    // 상품 유형 정보 getData
    async getProductSubTypes() {
      await getResourceTypeDatas().then(async (data) => {
        this.$util.convertArr(data, { productTypeName: 'text', productTypeCode: 'value' });
        this.resourceTypeItems = data;
        this.productTypeGroups = await getProductTypeGroups(data, 'parentProductTypeName', [
          GLOBAL_CDN
        ]);
        if (this.resourceTypeModel == '') {
          this.resourceTypeModel = this.resourceTypeItems[0].value;
          this.tempResourceTypeModel = this.resourceTypeModel;
        }
      });
    },

    // 주요 성능항목 getData
    async getProductMetric(param) {
      await getSummaryMetricDatas(this.resourceTypeModel, param).then((data) => {
        this.$util.convertArr(data, { perfTitle: 'text', metricKey: 'value' });
        this.metricItems = data;
      });
    },

    async checkProductSubTypeAuth(productTypeCode) {
      const authData = await this.$store.dispatch('authStore/checkProductSubTypeAuthorization', {
        productTypeCode
      });
      return authData.type === this.$const.AuthorizationResult.ALLOW;
    },

    // 상품유형 선택
    async onResourceTypeChange(reset = true) {
      this.resetValidate();

      // this.isResourceTypeAuth = await this.checkProductSubTypeAuth(this.resourceTypeModel);

      this.$util.validate([this.$refs.resourceTypeModel]);

      if (reset || !this.isResourceTypeAuth) {
        this.childResourceTypeItems = [];
        this.childResourceTypeModel = '';
      }

      if (this.isResourceTypeAuth) {
        this.resourceTypeName = _.find(this.resourceTypeItems, {
          value: this.resourceTypeModel
        }).text;
        if (this.isChildResourceType) {
          // 하위 상품 유형이 존재
          this.childResourceTypeItems = await this.$http.product.getListProductObjectTypes(
            this.resourceTypeModel
          );
          if (this.childResourceTypeModel == '')
            this.childResourceTypeModel = this.childResourceTypeItems[0].value;
          this.onChildResourceType(reset);
        } else {
          this.onChildResourceType(reset);
        }
      } else {
        this.metricItems = [];
        this.metricModel = [];
        this.onConfigChange();
      }
    },

    // 하위 상품 유형 선택
    async onChildResourceType(reset = true) {
      this.resetValidate();

      if (reset) {
        this.metricItems = [];
        this.metricModel = [];
      }

      let param = this.childResourceTypeModel ? { objectType: this.childResourceTypeModel } : {};
      await this.getProductMetric(param);

      this.onConfigChange();
    },

    // 초기 정보 셋팅
    async setDefault() {
      this.tempWidgetName = this.defaultConfig.chartAttr.title;
      if (this.isModifyMode) {
        this.resourceTypeModel = this.defaultConfig.chartAttr.widget.options.resourceType;
        this.tempResourceTypeModel = this.resourceTypeModel;
        this.metricModel.push(this.defaultConfig.chartAttr.widget.options.metricKey);
        this.childResourceTypeModel = this.defaultConfig.chartAttr.widget.options.childResourceType;
      }

      await this.getListProductAndPerformanceItem();
    },

    // 위젯 정보 update
    onConfigChange(isApiCall = true) {
      let configs = [];
      if (this.$util.isNotEmpty(this.metricModel)) {
        for (let i in this.metricModel) {
          const metric = this.metricModel[i];
          const metricObj = this.metricItems.find((item) => item.value == metric);

          let config = this.getCommonConfig();
          config.chartAttr.title = this.widgetName;

          config.chartAttr.widget.options.metricKey = metric;
          config.chartAttr.widget.options.resourceType = this.resourceTypeModel;
          config.chartAttr.widget.options.resourceTypeName = this.resourceTypeName;
          if (this.isChildResourceType) {
            config.chartAttr.widget.options.childResourceType = this.childResourceTypeModel;
            config.chartAttr.widget.options.objectType =
              this.childResourceTypeModel != '' &&
              this.notObjectItems[this.resourceTypeModel].includes(this.childResourceTypeModel)
                ? ''
                : this.childResourceTypeModel;
          } else {
            config.chartAttr.widget.options.childResourceType = '';
            config.chartAttr.widget.options.objectType = '';
          }

          if (metricObj) config.chartAttr.widget.options.perfTitle = metricObj.perfTitle;
          config.isApiCall = isApiCall;

          configs.push(config);
        }
      }
      this.$emit('configModify', configs);
    },

    /*************   validate check *************/
    validate() {
      this.validating = true;
      return this.$util.validate([
        this.$refs.widgetName,
        this.$refs.resourceTypeModel,
        this.$refs.metricChecked
      ]);
    },

    // validation check reset
    resetValidate() {
      this.validating = false;
      this.isResourceTypeAuth = true;
      this.$util.clearValidate([this.$refs.resourceTypeModel, this.$refs.metricChecked]);
    },

    // metric validation
    checkMetricEmpty(value) {
      this.isMessageShow = false;
      if (this.validating) {
        if (value.length === 0) {
          this.isMessageShow = true;
          return false;
        }
      }
      return true;
    },

    // 상품 선택 validate check
    checkResourceTypeModel(value) {
      if (!this.isResourceTypeAuth) return '';
      if (this.validating) {
        if (!this.checkEmpty(value)) return this.$t('message.select2', [this.$t('label.product')]);
      }
      return true;
    },

    // dirty 체크
    isDirtyCheck() {
      if (this.tempWidgetName !== this.widgetName) return true;
      if (this.tempResourceTypeModel !== this.resourceTypeModel) return true;
      if (this.metricModel.length > 0) return true;
      return false;
    },
    validateBtnComfirm() {
      if (this.checkWidgetName(this.widgetName) !== true) return true;
      if (this.checkResourceTypeModel(this.resourceTypeModel) !== true) return true;
      if (this.metricModel.length === 0) return true;
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 6px;
}

.area {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-bottom: 8px;
  }
}

.check_vertical {
  width: 100%;
  margin-top: 9px;
  margin-left: 0px !important;

  &:first-child {
    margin-top: 0px;
  }

  :deep(.lego-checkbox__label) {
    color: #1f2533 !important;
  }
}

.message {
  margin-left: 10px;
  color: #fc434e;
  font-size: 12px;
  text-align: right;
}

.performance .message {
  margin-left: 0px;
  color: #fc434e;
  font-size: 12px;
  text-align: right;
}

.lineIcon {
  margin: 2px 0 0 6px;
}

.content-wrapper {
  margin-top: 24px;
}
</style>
